import http from '@/utils/http';
import config from '@/config';
import { isLoggedIn } from '@/services/auth';

function screenLogger() {
  let logMessages = [];

  function addLog(message) {
    const timestamp = new Date().toISOString();
    const logMessage = `${timestamp} - ${message}`;
    logMessages.push(logMessage);
  }

  async function sendLogs(additionalFields = {}) {
    if (!isLoggedIn()) return;
    if (logMessages.length > 0) {
      const url = config.loggerUrl;
      const screenId = localStorage.getItem('screenId');
      try {
        if (screenId && url) {
          await http.post(url, {
            screen_id: screenId,
            logs: logMessages,
            ...additionalFields,
          });
          logMessages = [];
        }
      } catch (error) {
        console.error('Failed to send logs:', error);
      }
    }
  }

  return {
    addLog,
    sendLogs,
  };
}

export const logger = screenLogger();

export function sendCrashReport(data) {
  logger.addLog('Crash Report');
  if (data && typeof data === 'object') {
    logger.sendLogs(data);
  } else {
    logger.sendLogs({ error: String(data) });
  }
}
